import { buildProps, definePropType, mutable } from '@jdesign-vue/utils'
import { componentSizes } from '@jdesign-vue/constants'
import type Text from './text.vue'

import type { ExtractPropTypes, StyleValue } from 'vue'

export const textProps = buildProps({
  /**
   * @description text type
   */
  type: {
    type: String,
    values: ['primary', 'success', 'info', 'warning', 'error', ''],
    default: '',
  },
  /**
   * @description text size
   */
  size: {
    type: String,
    values: componentSizes,
    default: '',
  },
  /**
   * @description render ellipsis
   */
  truncated: {
    type: Boolean,
  },
  /**
   * @description maximum lines
   */
  lineClamp: {
    type: [String, Number],
  },
  /**
   * @description custom element tag
   */
  tag: {
    type: String,
    default: 'span',
  },
  dashed: {
    type: Boolean,
  },
  dashedColor: {
    type: String,
  },
  dashedSize: {
    type: [Number, String],
  },
  dashedOffset: {
    type: [Number, String],
  },
  status: {
    type: String,
    values: ['primary', 'success', 'info', 'warning', 'error', 'disable'],
  },
  statusStyle: {
    type: definePropType<StyleValue>([Object, Array, String]),
    default: () => mutable({} as const),
  },
} as const)
export type TextProps = ExtractPropTypes<typeof textProps>
export type TextInstance = InstanceType<typeof Text>
